import { render, staticRenderFns } from "./TimeLineElementBig.vue?vue&type=template&id=2c77a37e&scoped=true"
import script from "./TimeLineElementBig.vue?vue&type=script&lang=ts"
export * from "./TimeLineElementBig.vue?vue&type=script&lang=ts"
import style0 from "./TimeLineElementBig.vue?vue&type=style&index=0&id=2c77a37e&prod&lang=scss"
import style1 from "./TimeLineElementBig.vue?vue&type=style&index=1&id=2c77a37e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77a37e",
  null
  
)

export default component.exports